import styles from "../styles/Main.module.scss";
import { useState, useRef, useEffect, Fragment } from "react";

//비주얼
import visualBgImg01 from '../assets/images/visual/pc_hero_Image_1.png';
import visualBgImg02 from '../assets/images/visual/pc_hero_Image_2.png';
import visualBgImg03 from '../assets/images/visual/pc_hero_Image_3.png';
import visualBgMobileImg01 from '../assets/images/visual/mobile_hero_Image_1.png';
import visualBgMobileImg02 from '../assets/images/visual/mobile_hero_Image_2.png';
import visualBgMobileImg03 from '../assets/images/visual/mobile_hero_Image_3.png';

import scrollIcon from '../assets/images/visual/scroll-icon.svg';
import logo from '../assets/images/visual/logo.svg';
import logoTablet from '../assets/images/visual/logo-tablet.svg';
import logoMobile from '../assets/images/visual/logo-mobile.svg';
import footerLogo from '../assets/images/footer/footer-logo.svg';

//what-we-do
import whatWeDoIcon01 from '../assets/images/what-we-do/what-we-do-icon01.svg';
import whatWeDoIcon02 from '../assets/images/what-we-do/what-we-do-icon02.svg';
import whatWeDoIcon03 from '../assets/images/what-we-do/what-we-do-icon03.svg';

//our-technology
import OurTechnologyIcon01 from '../assets/images/our-technology/3dcube.svg';
import OurTechnologyIcon02 from '../assets/images/our-technology/cpu-charge.svg';
import OurTechnologyIcon03 from '../assets/images/our-technology/share.svg';
import OurTechnologyIcon04 from '../assets/images/our-technology/favorite-chart.svg';
import refreshIcon from '../assets/images/our-technology/icon-refresh.svg';
import detailArrow from '../assets/images/our-technology/arrow-detail.svg';

//change-management
import cmTeacher from '../assets/images/change-management/icon-teacher.svg';
import cmTriangle from '../assets/images/change-management/icon-triangle.svg';
import cmShapes from '../assets/images/change-management/icon-shapes.svg';
import cmArrow from '../assets/images/change-management/arrow-right.svg';

//innovation-technology
import ivChart from '../assets/images/innovation/icon-chart.svg';
import ivMouse from '../assets/images/innovation/icon-mouse.svg';
import ivClipboard from '../assets/images/innovation/icon-clipboard.svg';
import ivArrow from '../assets/images/innovation/arrow-right.svg';
import ivStep01 from '../assets/images/innovation/step01.png';
import ivStep02 from '../assets/images/innovation/step02.png';
import ivStep03 from '../assets/images/innovation/step03.png';
import ivStep04 from '../assets/images/innovation/step04.png';
import ivStep05 from '../assets/images/innovation/step05.png';

const CONTACT_MAIL = 'mailto:kys1227@tconnect.co.kr';

const scrollToId = (id) => (e) => {
  e.preventDefault();
  const target = document.getElementById(id);
  if (target) target.scrollIntoView({ behavior: 'smooth' });
};

// IntersectionObserver 기반 등장 애니메이션 훅 (신규 섹션 공용)
const useReveal = () => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0, rootMargin: '0px 0px -10% 0px' }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return { isVisible, ref };
};

const servicePortfolioData = [
  {
    title: '유지보수',
    items: [
      '고객 정보 인프라를 진단 후 최적의 유지관리 솔루션 제공',
      '서버, 네트워크 및 PC, 프린터 등 사무용 전산장비 유지관리',
      '전국 규모의 유지관리 조직을 통한 신속한 장애대응 서비스 보장',
      '온라인 장애처리 및 원격 지원 서비스 제공',
    ],
  },
  {
    title: '아웃소싱 서비스',
    items: [
      'IT 전문인력 지원',
      '고객사의 IT자원 위탁 운영',
      '전산자원 설치 관련 업무 위탁 운영',
      '공공기관 전산실 이전 작업 수행 (전산장비 및 네트워크)',
    ],
  },
  {
    title: 'IT 솔루션',
    items: [
      '방화벽, 서버보안 등 보안대책 수립 컨설팅 지원',
      'ITSM 시스템 구축 제공',
      '장애예측관리 시스템',
    ],
  },
];

const changeManagementData = [
  {
    no: '01',
    icon: cmTeacher,
    title: 'Copilot 교육',
    subtitle: 'Microsoft 365 Copilot 실무 활용 교육',
    desc: 'Word, Excel, PowerPoint, Outlook, Teams 등 매일 사용하는 업무 환경에서 Copilot을 바로 활용할 수 있도록 직무 맞춤 실습 중심으로 교육합니다. 최신 기능 업데이트를 반영한 커리큘럼으로 현업 적용성을 높입니다.',
    steps: [
      { title: '기초 이해', sub: '작동 원리' },
      { title: '앱별 실습', sub: 'Word · Excel · Teams' },
      { title: '프롬프트', sub: '직무별 작성법' },
      { title: '업무 적용', sub: '실무 정착' },
    ],
  },
  {
    no: '02',
    icon: cmTriangle,
    title: 'Copilot Studio 교육',
    subtitle: '업무용 AI 에이전트 제작 워크숍',
    desc: '코드 없이 현업 프로세스에 맞는 AI 에이전트를 직접 설계하고 제작합니다. 데이터 연결, 지식 소스 구성, Power Automate 연동, 배포까지 실습 산출물 중심으로 진행합니다.',
    steps: [
      { title: '에이전트 생성', sub: '기본 챗봇' },
      { title: '지식 연결', sub: 'Topic · Knowledge' },
      { title: '도구 연동', sub: 'Power Automate' },
      { title: '게시 · 운영', sub: 'M365 배포' },
    ],
  },
  {
    no: '03',
    icon: cmShapes,
    title: 'Agent Mock-up 개발',
    subtitle: '업무 맞춤형 에이전트 시연 및 PoC 구축',
    desc: '아이디어를 빠르게 검증할 수 있는 시연형 에이전트를 구축합니다. 유스케이스 발굴, 프로토타입 제작, 시연 시나리오 구성, 성과 지표 정의까지 도입 의사결정을 지원합니다.',
    steps: [
      { title: '유스케이스', sub: '과제 발굴' },
      { title: 'Mock-up 설계', sub: '화면 · 시나리오' },
      { title: '프로토타입', sub: '시연본 구축' },
      { title: '검증 · 확장', sub: 'KPI 정의' },
    ],
  },
];

const coreTechData = [
  {
    icon: ivChart,
    title: '의미 안정성 분석',
    desc: '문장의 표현 변화에도 핵심 의미가 안정적으로 유지되는지 측정해, 답변 품질에 필요한 정보를 선별합니다.',
  },
  {
    icon: ivMouse,
    title: '질문 중심 선택',
    desc: '질문과 직접 연결되는 문장을 우선 선택해 불필요한 컨텍스트를 줄이고 응답의 초점을 높입니다.',
  },
  {
    icon: ivClipboard,
    title: '엔터프라이즈 적용',
    desc: '기존 RAG 파이프라인에 미들웨어 형태로 연결해 내부 지식 검색과 AI 응답 프로세스에 빠르게 적용할 수 있습니다.',
  },
];

const howItWorksData = [
  { img: ivStep01, step: 'STEP 01', title: '내부 지식베이스', desc: '문서, 매뉴얼, 회의록 등 기업 내부 자료를 수집합니다.', core: false },
  { img: ivStep02, step: 'STEP 02', title: 'RAG 검색', desc: '질문과 관련된 문서 조각을 검색하고 후보를 구성합니다.', core: false },
  { img: ivStep03, step: 'STEP 03 · CORE', title: '컨텍스트 압축', desc: '응답에 필요한 핵심 문장만 선별해 토큰 사용량을 줄입니다.', core: true },
  { img: ivStep04, step: 'STEP 04', title: 'LLM API 호출', desc: '정제된 컨텍스트를 모델에 전달해 응답을 생성합니다.', core: false },
  { img: ivStep05, step: 'STEP 05', title: 'AI 응답', desc: '사용자에게 정확하고 빠른 답변을 제공합니다.', core: false },
];

const statData = [
  { big: '60~90%', small: '토큰 비용 절감 가능' },
  { big: 'Fast', small: '기존 RAG 흐름에 빠른 적용' },
  { big: 'No Training', small: '별도 학습 없이 운영 가능' },
];


function Main() {


  return (
    <>
      <div className={styles.main}>
        <MainVisual/>
        <WhatWeDo/>
        <OurTechnology/>
        <ServicePortfolio/>
        <ChangeManagement/>
        <InnovationTechnology/>
        <Footer/>
      </div>
    </>
  );
}

export default Main;





const useImageTransition = (images, interval = 3000) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [nextIndex, setNextIndex] = useState(1);
    const [isTransitioning, setIsTransitioning] = useState(false);
    const imageRefs = useRef(images.map(() => new Image()));

    // 이미지 프리로드
    useEffect(() => {
        images.forEach((src, index) => {
            const img = imageRefs.current[index];
            img.src = src;
        });
    }, [images]);

    useEffect(() => {
        const timer = setInterval(() => {
            setNextIndex((currentIndex + 1) % images.length);
            setIsTransitioning(true);

            setTimeout(() => {
                setCurrentIndex((currentIndex + 1) % images.length);
                setIsTransitioning(false);
            }, 1000);
        }, interval);

        return () => clearInterval(timer);
    }, [currentIndex, images.length, interval]);

    return { currentIndex, nextIndex, isTransitioning };
};

const MainVisual = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
    const pcImages = [visualBgImg01, visualBgImg02, visualBgImg03];
    const mobileImages = [visualBgMobileImg01, visualBgMobileImg02, visualBgMobileImg03];
    const images = isMobile ? mobileImages : pcImages;
    const { currentIndex, nextIndex, isTransitioning } = useImageTransition(images);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 767);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className={styles.mainVisual}>
            <div className={styles.mainVisualBg}>
                {images.map((src, index) => (
                    <img
                        key={src}
                        src={src}
                        alt="visual-bg"
                        style={{
                            opacity: index === currentIndex ? 1 :
                                    index === nextIndex && isTransitioning ? 1 : 0
                        }}
                    />
                ))}
            </div>
            <div className={styles.inner}>
                <div className={styles.mainVisualContent}>
                    <h2 className={styles.mainVisualTitle}>
                        Connect with Tech,<br />
                        Grow with Trust.
                    </h2>
                    <p className={styles.mainVisualText}>
                        파트너와 함께 새로운 가치를 만들어갑니다.
                    </p>
                    <a
                      className={styles.mainVisualButton}
                      href="mailto:kys1227@tconnect.co.kr"
                    >Contact us</a>
                </div>
                <p className={styles.mainVisualScroll}>
                    <img src={scrollIcon} alt="scroll" />
                </p>
                <p className={styles.mainVisualLogo}>
                    <img src={logo} className={styles.mainVisualLogoPc} alt="logo" />
                    <img src={logoTablet} className={styles.mainVisualLogoTablet} alt="logo" />
                    <img src={logoMobile} className={styles.mainVisualLogoMobile} alt="logo" />
                </p>
            </div>
        </div>
    );
};


const WhatWeDo = () => {
  const [isVisible, setIsVisible] = useState(false);
  const lastItemRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      {
        threshold: 0.1,
        rootMargin: '0px'
      }
    );

    if (lastItemRef.current) {
      observer.observe(lastItemRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <div id="what-we-do" className={styles.whatWeDo}>
        <div className={styles.inner}>
          <h3>What We Do</h3>
          <h4>
            국내외 선도 기술 파트너의 역량을 결집해,
            <span>검증된 솔루션과 실행력 있는 IT 서비스를 제공합니다.</span>
          </h4>
          <div className={`${styles.whatWeDoContent} ${isVisible ? styles.active : ''}`}>
            <div className={styles.whatWeDoContentItem}>
              <img src={whatWeDoIcon01} alt="what-we-do-icon01" />
              Expertise & Experience
            </div>
            <div className={styles.whatWeDoContentItem}>
              <img src={whatWeDoIcon02} alt="what-we-do-icon02" />
              Industry-Leading Partnerships
            </div>
            <div className={styles.whatWeDoContentItem} ref={lastItemRef}>
              <img src={whatWeDoIcon03} alt="what-we-do-icon03" />
              End-to-End Support
            </div>
          </div>
        </div>
      </div>
    </>
  );
};


const OurTechnology = () => {
  const [isVisible, setIsVisible] = useState(false);
  const lastItemRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // 한 번만 실행되도록 observer 해제
        }
      },
      {
        threshold: 0.1, // 요소가 10% 보일 때 감지
        rootMargin: '0px' // 뷰포트 하단에 정확히 닿았을 때 감지
      }
    );

    if (lastItemRef.current) {
      observer.observe(lastItemRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <div className={styles.ourTechnology}>
        <span className={`${styles.ourTechnologyCircle} ${styles.ourTechnologyCircle1}`} />
        <span className={`${styles.ourTechnologyCircle} ${styles.ourTechnologyCircle2}`} />
        <span className={`${styles.ourTechnologyCircle} ${styles.ourTechnologyCircle3}`} />
        <div className={styles.inner}>
          <div className={styles.ourTechnologyLeft}>
            <h3>
              Our Technology
            </h3>
            <h4>
              기술 조달부터 구축, 운영, 변화관리까지
              <span>필요한 기술을 더 빠르고 정확하게 도입할 수 있도록 지원합니다.</span>
            </h4>
            <a
              className={styles.ourTechnologyButton}
              href="mailto:kys1227@tconnect.co.kr"
            >지금 문의하기</a>
          </div>
          <div className={`${styles.ourTechnologyContent} ${isVisible ? styles.active : ''}`}>
            <div className={styles.ourTechnologyContentItem}>
              <img src={OurTechnologyIcon01} alt="our-technology-icon01" />
              시스템 통합 및 구축
            </div>
            <div className={styles.ourTechnologyContentItem}>
              <img src={OurTechnologyIcon02} alt="our-technology-icon02" />
              IT 아웃소싱
            </div>
            <div className={styles.ourTechnologyContentItem}>
              <img src={OurTechnologyIcon03} alt="our-technology-icon03" />
              장비 구매 및 이전 서비스
            </div>
            <div className={styles.ourTechnologyContentItem} ref={lastItemRef}>
              <img src={OurTechnologyIcon04} alt="our-technology-icon04" />
              컨설팅
            </div>
            <a
              className={styles.ourTechnologyBanner}
              href="#change-management"
              onClick={scrollToId('change-management')}
            >
              <img className={styles.ourTechnologyBannerIcon} src={refreshIcon} alt="" />
              <div className={styles.ourTechnologyBannerBody}>
                <span className={styles.ourTechnologyBannerBadge}>NEW</span>
                <p className={styles.ourTechnologyBannerTitle}>Microsoft 변화관리</p>
                <p className={styles.ourTechnologyBannerDesc}>
                  Copilot 교육 · Copilot Studio 교육 · 업무 맞춤형 Agent Mock-up 개발
                </p>
              </div>
              <span className={styles.ourTechnologyBannerMore}>
                자세히 보기
                <img src={detailArrow} alt="" />
              </span>
            </a>
          </div>
          <a
            className={`${styles.ourTechnologyButton} ${styles.mobile}`}
            href="mailto:kys1227@tconnect.co.kr"
          >지금 문의하기</a>
        </div>
      </div>
    </>
  );
};


const ServicePortfolio = () => {
  const { isVisible, ref } = useReveal();

  return (
    <div id="service-portfolio" className={styles.servicePortfolio}>
      <div className={styles.inner}>
        <div className={styles.servicePortfolioHead}>
          <h3>Service Portfolio</h3>
          <h4>
            전산장비 유지보수부터 아웃소싱, IT 솔루션까지
            <span>고객의 IT 환경 전반을 아우르는 서비스를 제공합니다.</span>
          </h4>
        </div>
        <div
          className={`${styles.servicePortfolioList} ${isVisible ? styles.active : ''}`}
          ref={ref}
        >
          {servicePortfolioData.map((card) => (
            <div className={styles.servicePortfolioCard} key={card.title}>
              <p className={styles.servicePortfolioCardTitle}>{card.title}</p>
              <ul className={styles.servicePortfolioItems}>
                {card.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};


const ChangeManagement = () => {
  const { isVisible, ref } = useReveal();

  return (
    <div id="change-management" className={styles.changeManagement}>
      <div className={styles.inner}>
        <div className={styles.changeManagementHead}>
          <h3>Change Management</h3>
          <h4>
            Microsoft Copilot 도입, 교육에서 현장 적용까지
            <span>조직이 실제로 활용할 수 있도록 3가지 영역으로 변화관리를 지원합니다.</span>
          </h4>
        </div>
        <div
          className={`${styles.changeManagementList} ${isVisible ? styles.active : ''}`}
          ref={ref}
        >
          {changeManagementData.map((row) => (
            <div
              className={styles.changeManagementRow}
              key={row.no}
            >
              <div className={styles.changeManagementNo}>
                <span className={styles.changeManagementNoIcon}>
                  <img src={row.icon} alt="" />
                </span>
                <p>{row.no}</p>
              </div>
              <span className={styles.changeManagementDivider} />
              <div className={styles.changeManagementBody}>
                <div className={styles.changeManagementTitle}>
                  <p className={styles.changeManagementName}>{row.title}</p>
                  <p className={styles.changeManagementSub}>{row.subtitle}</p>
                </div>
                <p className={styles.changeManagementDesc}>{row.desc}</p>
                <div className={styles.changeManagementSteps}>
                  {row.steps.map((step, stepIndex) => (
                    <Fragment key={step.title}>
                      <div className={styles.changeManagementStep}>
                        <p className={styles.changeManagementStepTitle}>{step.title}</p>
                        <p className={styles.changeManagementStepSub}>{step.sub}</p>
                      </div>
                      {stepIndex < row.steps.length - 1 && (
                        <img className={styles.changeManagementStepArrow} src={cmArrow} alt="" />
                      )}
                    </Fragment>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};


const InnovationTechnology = () => {
  const core = useReveal();
  const works = useReveal();
  const stats = useReveal();

  return (
    <div className={styles.innovation}>
      <span className={`${styles.innovationCircle} ${styles.innovationCircle1}`} />
      <span className={`${styles.innovationCircle} ${styles.innovationCircle2}`} />
      <span className={`${styles.innovationCircle} ${styles.innovationCircle3}`} />
      <div className={styles.inner}>
        <div className={styles.innovationHead}>
          <h3>Innovation Technology</h3>
          <h4>
            AI가 참고할 정보를 더 정확하고 효율적으로 선별합니다.
            <span>Knowledge Entropy 기반의 컨텍스트 압축 기술로 응답 품질은 유지하면서 토큰 사용량을 줄입니다.</span>
          </h4>
        </div>

        <div className={styles.innovationGroup}>
          <p className={styles.innovationLabel}>CORE TECHNOLOGY</p>
          <div
            className={`${styles.innovationCore} ${core.isVisible ? styles.active : ''}`}
            ref={core.ref}
          >
            {coreTechData.map((item) => (
              <div className={styles.innovationCoreItem} key={item.title}>
                <span className={styles.innovationCoreIcon}>
                  <img src={item.icon} alt="" />
                </span>
                <div className={styles.innovationCoreText}>
                  <p className={styles.innovationCoreTitle}>{item.title}</p>
                  <p className={styles.innovationCoreDesc}>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.innovationGroup}>
          <p className={styles.innovationLabel}>HOW IT WORKS</p>
          <div className={styles.innovationWorksHead}>
            <p className={styles.innovationWorksTitle}>컨텍스트 압축 프로세스</p>
            <p className={styles.innovationWorksSub}>
              내부 지식베이스에서 AI 응답까지, 5단계 흐름으로 필요한 정보만 정교하게 전달합니다.
            </p>
          </div>
          <div
            className={`${styles.innovationFlow} ${works.isVisible ? styles.active : ''}`}
            ref={works.ref}
          >
            {howItWorksData.map((stepItem, idx) => (
              <Fragment key={stepItem.step}>
                <div
                  className={`${styles.innovationStep} ${stepItem.core ? styles.core : ''}`}
                >
                  <div className={styles.innovationStepThumb}>
                    <img src={stepItem.img} alt="" />
                  </div>
                  <div className={styles.innovationStepText}>
                    <p className={styles.innovationStepLabel}>{stepItem.step}</p>
                    <p className={styles.innovationStepTitle}>{stepItem.title}</p>
                    <p className={styles.innovationStepDesc}>{stepItem.desc}</p>
                  </div>
                </div>
                {idx < howItWorksData.length - 1 && (
                  <img className={styles.innovationFlowArrow} src={ivArrow} alt="" />
                )}
              </Fragment>
            ))}
          </div>
        </div>

        <div
          className={`${styles.innovationStats} ${stats.isVisible ? styles.active : ''}`}
          ref={stats.ref}
        >
          {statData.map((stat) => (
            <div className={styles.innovationStat} key={stat.big}>
              <p className={styles.innovationStatBig}>{stat.big}</p>
              <p className={styles.innovationStatSmall}>{stat.small}</p>
            </div>
          ))}
        </div>

        <div className={styles.innovationCtaWrap}>
          <a className={styles.innovationCta} href={CONTACT_MAIL}>
            기술 도입 문의하기
            <img src={ivArrow} alt="" />
          </a>
        </div>
      </div>
    </div>
  );
};


const Footer = () => {
  return (
      <>
        <div className={styles.footer}>
          <div className={styles.inner}>
            <div className={styles.footerLeft}>
              <p className={styles.footerLeftTitle}>테크커넥트(주)</p>
              <div className={styles.footerLeftText}>
                <dl className={styles.footerLeftTextItem}>
                  <dt>대표 <p>김영수</p></dt>
                  <dd>
                    사업자등록번호
                    <p>230-87-02707</p>
                  </dd>
                </dl>
                <dl className={styles.footerLeftTextItem}>
                  <dt>주소</dt>
                  <dd>
                    <p>서울 구로구 디지털로26길 5, 1305호(에이스 하이엔드타워 1차)</p>
                  </dd>
                </dl>
                <dl className={styles.footerLeftTextItem}>
                  <dt>문의사항<p>kys1227@tconnect.co.kr</p></dt>
                  <dd>
                    팩스번호
                    <p>02-6455-3816</p>
                  </dd>
                </dl>
              </div>
              {/* <ul className={styles.footerLeftLink}>
                <li>
                  <a href="#what-we-do" onClick={scrollToId('what-we-do')}>
                    회사소개
                  </a>
                </li>
                <li>
                  <a href="/">
                    이용약관
                  </a>
                </li>
                <li>
                  <a href="/">
                    개인정보처리방침
                  </a>
                </li>
              </ul> */}
            </div>
            <div className={styles.footerRight}>
              <a
                href="/"
                className={styles.footerRightLogo}
                onClick={(e) => {
                  e.preventDefault();
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
              >
                <img src={footerLogo} alt="logo" />
              </a>
            </div>
          </div>
        </div>
      </>
  );
};